webpackJsonp([103953826085436],{

/***/ 167:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMy4yNSAxMy41OCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMzNjdkYmY7fS5jbHMtMntmaWxsOiM1ZGMyZWY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAzMzwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNS4yOSw5LjIxYS40Ny40NywwLDAsMS0uMzUtLjE1TDMuNiw3LjY5YS41MS41MSwwLDAsMSwwLS43MS41LjUsMCwwLDEsLjcxLDBsMSwxTDguOTQsNC41MmEuNS41LDAsMSwxLC42OS43MmwtNCwzLjgzQS41Mi41MiwwLDAsMSw1LjI5LDkuMjFaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNNi42MywxMy41OEE2LjcxLDYuNzEsMCwwLDEsMCw2Ljc5LDYuNzIsNi43MiwwLDAsMSw2LjYzLDBhNi43Miw2LjcyLDAsMCwxLDYuNjIsNi43OUE2LjcxLDYuNzEsMCwwLDEsNi42MywxMy41OFpNNi42MywxQTUuNzIsNS43MiwwLDAsMCwxLDYuNzlhNS43MSw1LjcxLDAsMCwwLDUuNjMsNS43OSw1LjcxLDUuNzEsMCwwLDAsNS42Mi01Ljc5QTUuNzEsNS43MSwwLDAsMCw2LjYzLDFaIi8+PC9zdmc+"

/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/digital-platform-cube.051717aa.png";

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.AppNeedsComponent = undefined;
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(5);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _applicationNeeds = __webpack_require__(127);
	
	__webpack_require__(158);
	
	var _checkMark = __webpack_require__(167);
	
	var _checkMark2 = _interopRequireDefault(_checkMark);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// eslint-disable-next-line no-unused-vars
	var learnMoreLinks = function learnMoreLinks(t) {
	    return [{
	        isTitle: true,
	        title: t("bapis.learn-more.title")
	    }, {
	        title: t("bapis.learn-more.item-1"),
	        url: "",
	        external: false
	    }, {
	        isBlock: true
	    }, {
	        title: t("bapis.learn-more.item-2"),
	        url: "",
	        external: false
	    }, {
	        isBlock: true
	    }, {
	        title: t("bapis.learn-more.item-2"),
	        url: "",
	        external: false
	    }, {
	        isBlock: true
	    }, {
	        title: t("bapis.learn-more.item-3"),
	        url: "",
	        external: false
	    }, {
	        isBlock: true
	    }, {
	        title: t("bapis.learn-more.item-4"),
	        url: "",
	        external: false
	    }];
	};
	
	var AppNeedsComponent = exports.AppNeedsComponent = (_dec = (0, _reactI18next.translate)("index"), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(AppNeedsComponent, _Component);
	
	    function AppNeedsComponent(props) {
	        _classCallCheck(this, AppNeedsComponent);
	
	        return _possibleConstructorReturn(this, _Component.call(this, props));
	    }
	
	    AppNeedsComponent.prototype.renderBox = function renderBox(item, index) {
	        if (item.isButton) {
	            return _react2.default.createElement(
	                "span",
	                { className: "btn btn-primary", key: index, onClick: function onClick() {
	                        return (0, _gatsbyLink.push)("/business-apis");
	                    } },
	                item.title
	            );
	        } else {
	            return _react2.default.createElement(
	                "span",
	                { key: index },
	                _react2.default.createElement("img", { src: _checkMark2.default }),
	                item.title
	            );
	        }
	    };
	
	    AppNeedsComponent.prototype.renderLink = function renderLink(link, index) {
	        if (link.isTitle) {
	            return _react2.default.createElement(
	                "span",
	                { key: index, className: "title" },
	                link.title
	            );
	        } else if (link.isBlock) {
	            return _react2.default.createElement("span", { key: index, className: "bullet" });
	        } else {
	            return _react2.default.createElement(
	                "span",
	                { key: index, className: "link" },
	                link.title
	            );
	        }
	    };
	
	    AppNeedsComponent.prototype.render = function render() {
	        var _this2 = this;
	
	        var t = this.props.t;
	
	
	        return _react2.default.createElement(
	            "div",
	            { className: "col-10 col-lg-8 col-xl-6 km-app-needs-component" },
	            _react2.default.createElement(
	                "div",
	                { className: "subtitle" },
	                t("bapis.needs.title")
	            ),
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    { className: "needs-row" },
	                    (0, _applicationNeeds.applicationNeeds)(t).row1.map(function (item, index) {
	                        return _this2.renderBox(item, index);
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "needs-row" },
	                    (0, _applicationNeeds.applicationNeeds)(t).row2.map(function (item, index) {
	                        return _this2.renderBox(item, index);
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "needs-row" },
	                    (0, _applicationNeeds.applicationNeeds)(t).row3.map(function (item, index) {
	                        return _this2.renderBox(item, index);
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "needs-row" },
	                    (0, _applicationNeeds.applicationNeeds)(t).row4.map(function (item, index) {
	                        return _this2.renderBox(item, index);
	                    })
	                )
	            )
	        );
	    };
	
	    return AppNeedsComponent;
	}(_react.Component), _class2.propTypes = {
	    t: _propTypes2.default.func
	}, _temp)) || _class);

/***/ }),

/***/ 158:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.DigitalPlatformComponent = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(5);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(159);
	
	var _digitalPlatform = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DigitalPlatformComponent = exports.DigitalPlatformComponent = (_dec = (0, _reactI18next.translate)("index"), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(DigitalPlatformComponent, _Component);
	
	    function DigitalPlatformComponent(props) {
	        _classCallCheck(this, DigitalPlatformComponent);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = {
	            lang: props.i18n.language
	        };
	        return _this;
	    }
	
	    DigitalPlatformComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.setState(_extends({}, this.state, { lang: nextProps.i18n.language }));
	    };
	
	    DigitalPlatformComponent.prototype.renderLink = function renderLink(item) {
	        if (item.external) {
	            return _react2.default.createElement(
	                "a",
	                { href: item.url, target: "_blank", rel: "noreferrer noopener" },
	                item.title
	            );
	        } else {
	            return _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: item.url },
	                item.title
	            );
	        }
	    };
	
	    DigitalPlatformComponent.prototype.render = function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            t = _props.t,
	            noHeader = _props.noHeader,
	            noButton = _props.noButton;
	
	
	        var numOfRows = Math.ceil((0, _digitalPlatform.digitalPlatformProducts)(t).length / 3);
	        var indexOfItemInBeforelastRow = (numOfRows - 1) * 3 - 1;
	
	        var showHeader = noHeader === undefined ? true : !noHeader;
	        var showButton = noButton === undefined ? true : !noButton;
	        var isUntranslated = this.state.lang === "sl" || this.state.lang === "de";
	        if (showButton && isUntranslated) {
	            showButton = false;
	        }
	
	        return _react2.default.createElement(
	            "div",
	            { className: "km-digital-platform-component" },
	            showHeader ? _react2.default.createElement(
	                "div",
	                { className: "title" },
	                _react2.default.createElement(
	                    "h1",
	                    null,
	                    t("digital-platform.title")
	                )
	            ) : null,
	            showHeader ? _react2.default.createElement(
	                "div",
	                { className: "subtitle" },
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    t("digital-platform.subtitle")
	                )
	            ) : null,
	            _react2.default.createElement(
	                "div",
	                { className: "grid" },
	                (0, _digitalPlatform.digitalPlatformProducts)(t).map(function (item, index) {
	                    return _react2.default.createElement(
	                        "div",
	                        { className: index > indexOfItemInBeforelastRow ? "last-row grid-item" : "grid-item", key: index },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "title" },
	                            _this2.renderLink(item)
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "desc" },
	                            item.description
	                        )
	                    );
	                })
	            ),
	            showButton ? _react2.default.createElement(
	                "div",
	                { className: "button-area" },
	                _react2.default.createElement(
	                    "button",
	                    { onClick: function onClick() {
	                            return (0, _gatsbyLink.push)("/digital-platform");
	                        }, className: "btn btn-primary" },
	                    t("header.tiles.buttons.learn-more")
	                )
	            ) : null
	        );
	    };
	
	    return DigitalPlatformComponent;
	}(_react.Component), _class2.propTypes = {
	    t: _propTypes2.default.func,
	    i18n: _propTypes2.default.object,
	    noHeader: _propTypes2.default.bool,
	    noButton: _propTypes2.default.bool
	}, _temp)) || _class);

/***/ }),

/***/ 159:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _appNeeds = __webpack_require__(123);
	
	Object.defineProperty(exports, "AppNeedsComponent", {
	  enumerable: true,
	  get: function get() {
	    return _appNeeds.AppNeedsComponent;
	  }
	});
	
	var _digitalPlatform = __webpack_require__(124);
	
	Object.defineProperty(exports, "DigitalPlatformComponent", {
	  enumerable: true,
	  get: function get() {
	    return _digitalPlatform.DigitalPlatformComponent;
	  }
	});

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.applicationNeeds = undefined;
	
	var _needs = __webpack_require__(128);
	
	var applicationNeeds = exports.applicationNeeds = function applicationNeeds(t) {
	    return {
	        row1: [new _needs.Needs(t("bapis.needs.item-1")), new _needs.Needs(t("bapis.needs.item-2")), new _needs.Needs(t("bapis.needs.item-8"))],
	        row2: [new _needs.Needs(t("bapis.needs.item-4")), new _needs.Needs(t("bapis.needs.item-5")), new _needs.Needs(t("bapis.needs.item-6"))],
	        row3: [new _needs.Needs(t("bapis.needs.item-3")), new _needs.Needs(t("bapis.needs.item-9")), new _needs.Needs(t("bapis.needs.item-10"))],
	        row4: [new _needs.Needs(t("bapis.needs.item-7")), new _needs.Needs(t("bapis.needs.browse"), true)]
	    };
	};

/***/ }),

/***/ 128:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Needs = exports.Needs = function Needs(title, isButton) {
	    _classCallCheck(this, Needs);
	
	    this.title = title;
	    this.isButton = isButton !== undefined ? isButton : false;
	};

/***/ }),

/***/ 614:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactI18next = __webpack_require__(5);
	
	__webpack_require__(614);
	
	var _digitalPlatformCube = __webpack_require__(696);
	
	var _digitalPlatformCube2 = _interopRequireDefault(_digitalPlatformCube);
	
	var _exportShared = __webpack_require__(12);
	
	var _export = __webpack_require__(125);
	
	var _footer = __webpack_require__(8);
	
	var _constants = __webpack_require__(34);
	
	var _googleAnalytics = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DigitalPlatformPage = (_dec = (0, _reactI18next.translate)("digital-platform"), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(DigitalPlatformPage, _Component);
	
	    function DigitalPlatformPage(props) {
	        _classCallCheck(this, DigitalPlatformPage);
	
	        return _possibleConstructorReturn(this, _Component.call(this, props));
	    }
	
	    DigitalPlatformPage.prototype.componentDidMount = function componentDidMount() {
	        _googleAnalytics.GoogleAnalyticsService.registerPageView();
	    };
	
	    DigitalPlatformPage.prototype.render = function render() {
	        var t = this.props.t;
	
	        return _react2.default.createElement(
	            "div",
	            { className: "km-digital-platform-page" },
	            _react2.default.createElement(_reactHelmet.Helmet, { title: t("meta.title") }),
	            _react2.default.createElement(
	                "div",
	                { className: "container-fluid header" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "row justify-content-center align-items-center" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "col-9 col-md-4 col-lg-2 header-image" },
	                        _react2.default.createElement("img", { src: _digitalPlatformCube2.default })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "col-9 col-md-4" },
	                        _react2.default.createElement(
	                            "h1",
	                            null,
	                            t("header.title")
	                        ),
	                        _react2.default.createElement(
	                            "h2",
	                            null,
	                            t("header.subtitle")
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "container-fluid dark-blue-section" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "row justify-content-center" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "col-10 p-0" },
	                        _react2.default.createElement(_exportShared.ArrowDividerComponent, { theme: "white", corner: 1 })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "col-10 col-xl-6" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "row flex-column mt-4" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-10" },
	                                _react2.default.createElement(
	                                    "h1",
	                                    { className: "text-center" },
	                                    t("digit-strategy.title")
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    { className: "text-center" },
	                                    t("digit-strategy.subtitle-1")
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    { className: "text-center" },
	                                    t("digit-strategy.subtitle-2"),
	                                    ":"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-10" },
	                                _react2.default.createElement(_exportShared.ArrowPointerComponent, { direction: "down" })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "row justify-content-center" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-10" },
	                                _react2.default.createElement(_export.DigitalPlatformComponent, { linkToBlog: true, noHeader: true, noButton: true })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-10" },
	                                _react2.default.createElement(_exportShared.ArrowPointerComponent, { direction: "down" })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-10" },
	                                _react2.default.createElement(
	                                    "h2",
	                                    { className: "text-center" },
	                                    t("digit-platform.title")
	                                )
	                            ),
	                            _react2.default.createElement("div", { className: "col-10 button-area" })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "col-10 p-0" },
	                        _react2.default.createElement(_exportShared.ArrowDividerComponent, { theme: "white", corner: 3 })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "container-fluid" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "row justify-content-center what-can-section" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "col-9 col-xl-6" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-10" },
	                                _react2.default.createElement(
	                                    "h2",
	                                    { className: "text-center" },
	                                    t("what-can.title")
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-10 col-md-5 left-side" },
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    t("what-can.left.para-1")
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    t("what-can.left.para-2")
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    t("what-can.left.para-3")
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-10 col-md-5" },
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    t("what-can.right.para-1")
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                        "strong",
	                                        null,
	                                        t("what-can.right.para-2.strong"),
	                                        ":"
	                                    ),
	                                    "\xA0",
	                                    t("what-can.right.para-2.text")
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(_footer.Footer, { contact: true })
	        );
	    };
	
	    return DigitalPlatformPage;
	}(_react.Component), _class2.propTypes = {
	    t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = DigitalPlatformPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-digital-platform-index-js-b36d9ef146ee3ac7e851.js